// TODO(ssr-legacy-removal): Remove this CSR layout after one stable SSR release; see
// docs/features/ssr-rsc-seo/8-verification-and-docs.md.
import { useEffect, useState } from 'react';
import { DEFAULT_CONTENT_LINKS, type WebsiteContentLinks } from '../utils/websiteSsr/content';
import { getApiPath } from './pathPrefix';
import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { StoreProvider } from './client/StoreProvider';
import { GlobalErrorBanner } from './client/GlobalErrorBanner';
import Header from './components/Header';
import SiteFooter from './components/SiteFooter';
import { useWebsiteAppContext } from './hooks/useWebsiteAppContext';
import { useWebTheme } from './hooks/useWebTheme';
import { getLocalizedText, getNormalizedLanguageCode } from '../miniapp/i18n/localization';

function LegacyLayout() {
  useWebTheme();
  const { t, i18n } = useTranslation();
  const { appConfig } = useWebsiteAppContext();
  const language = getNormalizedLanguageCode(i18n.resolvedLanguage ?? i18n.language);
  const [links,setLinks] = useState<WebsiteContentLinks>(DEFAULT_CONTENT_LINKS);
  useEffect(() => {
    const controller = new AbortController();
    void fetch(getApiPath('/web/content'),{signal:controller.signal}).then((response) => response.ok ? response.json() : null).then((response: {data:WebsiteContentLinks} | null) => {if(response) setLinks(response.data);}).catch(() => {});
    return () => controller.abort();
  }, []);
  const footerText = getLocalizedText(appConfig?.websiteFooterText ?? '', appConfig?.websiteFooterTextTranslations, language);
  return <div className="min-h-screen flex flex-col"><Header logoUrl={appConfig?.websiteLogoUrl ?? null} />
    <main className="flex-1 w-full"><div className="max-w-web mx-auto px-[var(--web-side-padding)] pt-5 pb-10"><GlobalErrorBanner /><Outlet /></div></main>
    <SiteFooter language={language} links={links} text={footerText} imageUrl={appConfig?.websiteFooterImageUrl ?? null} imageAlt={t('website.footer.imageAlt')} />
  </div>;
}

export default function App() {
  return <StoreProvider ssr={false} initialSessionUser={null} initialAppConfig={null}><LegacyLayout /></StoreProvider>;
}
